import { LinearProgress } from 'react-admin';
import { CardContent, Typography } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { useNativeCampaign } from './forms/hooks/useNativeCampaign';

/**
 * Minimal campaign shape used by exclusion-label chips on native campaign show.
 * Kept here so legacy redirect file remains the shared type home for this shape.
 */
export type CampaignRecord = {
  advertiser?: { id: string; name: string };
  archived?: boolean;
  campaignNumber?: number;
  endDate?: string;
  id: string;
  lineItems?: { id: string; name: string }[];
  name?: string;
  startDate?: string;
};

/**
 * Legacy `/placementCampaigns/:id/show` route (MD-5186 Phase A/B).
 * Thin redirect shell — no Placements REST provider. Resolves native UUID via
 * GraphQL and sends bookmarks to `/campaigns/<uuid>/show`.
 */
export const CampaignShow = () => {
  const { id } = useParams();
  const { campaign, isLoading, error } = useNativeCampaign(id);

  if (!id) return null;
  if (isLoading) return <LinearProgress />;
  if (campaign?.id) {
    return <Navigate to={`/campaigns/${encodeURIComponent(String(campaign.id))}/show`} replace />;
  }

  const errorMessage = error instanceof Error ? error.message : undefined;
  return (
    <CardContent>
      <Typography color="error">{errorMessage ?? `Campaign not found for id ${id}`}</Typography>
    </CardContent>
  );
};
